import {Check, Close, Remove} from '@mui/icons-material';
import {VoteEnum} from '../../types';

function VoteIcon({type}: {type: VoteEnum}) {
  switch (type) {
    case 'yes':
      return <Check fontSize="inherit" />;
    case 'abstain':
      return <Remove fontSize="inherit" />;
    case 'no':
      return <Close fontSize="inherit" />;
  }
}

export default VoteIcon;
